import * as React from 'react';

import classnames from 'classnames';

import {ChevronLeftIcon, ChevronRightIcon} from '../icon';

import type {Direction} from './slideshow-container';

import styles from './slideshow-arrow.module.css';

type Props = {
    direction: Direction;
    selectedSlide: number;
    slideCount: number;
    onSlideChange: (newSlideNum: number) => void;
    isCircular?: boolean;
};

export function SlideshowArrow(props: Props) {
    const {direction, selectedSlide, slideCount, isCircular, onSlideChange} = props;

    const canScroll =
        direction === 'left'
            ? isCircular || selectedSlide > 0
            : isCircular || selectedSlide < slideCount - 1;

    const styleNames = classnames({
        [styles['slideshow-arrow']]: canScroll,
        [styles['slideshow-arrow--hidden']]: !canScroll,
        [styles['slideshow-arrow--left']]: direction === 'left',
        [styles['slideshow-arrow--right']]: direction === 'right',
    });

    return (
        <button
            onClick={() => {
                if (!canScroll) return;

                const newSlideNum = direction === 'left' ? selectedSlide - 1 : selectedSlide + 1;

                onSlideChange(
                    isCircular
                        ? ((newSlideNum % slideCount) + slideCount) % slideCount
                        : newSlideNum
                );
            }}
            className={styleNames}
        >
            {direction === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </button>
    );
}
